import {API} from 'aws-amplify';
import axios from 'axios';

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === 'true';
const baseURL = process.env.REACT_APP_APIURL;

export async function updateProfileApi(profile: any) {
  if (isLocalAuth) {
    return axios.patch(`${baseURL}/user/update/${profile.userId}`, profile).then(res => res.data);
  }
  return API.patch('Backend', `/user/update/${profile.userId}`, {body: profile});
}
